import * as React from 'react'

export const LimitedAvailability = props => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 540 300">
        <path fill="#F09409" d="m150 0 90 90-30 30-90-90z"></path>
        <path fill="#C6C6C6" d="m420 30 120 120-120 120-30-30 90-90-90-90z"></path>
        <path fill="#F09409" d="m330 180-30 30 90 90 30-30z"></path>
        <path fill="#C6C6C6" d="m120 30 30 30-90 90 90 90-30 30L0 150z"></path>
        <path fill="#F09409" d="m390 0 30 30-270 270-30-30z"></path>
    </svg>
)
